import { DollarSign, CreditCard, TrendingDown, Repeat } from "lucide-react";
import type { FinanceSummary } from "../../lib/types";

interface Props {
  summary: FinanceSummary;
}

const fmt = (n: number) =>
  n.toLocaleString("es-MX", { maximumFractionDigits: 0 });

export function SummaryCards({ summary }: Props) {
  const cards = [
    {
      label: "Deuda Total",
      value: `$${fmt(summary.total_debt)}`,
      icon: DollarSign,
      color: "text-red-400",
      bg: "bg-red-500/10",
    },
    {
      label: "Disponible",
      value: `$${fmt(summary.total_available)}`,
      icon: CreditCard,
      color: "text-emerald-400",
      bg: "bg-emerald-500/10",
    },
    {
      label: "Intereses / Mes",
      value: `$${fmt(summary.monthly_interest)}`,
      icon: TrendingDown,
      color: "text-yellow-400",
      bg: "bg-yellow-500/10",
    },
    {
      label: "Suscripciones / Mes",
      value: `$${fmt(summary.monthly_subscriptions)}`,
      icon: Repeat,
      color: "text-blue-400",
      bg: "bg-blue-500/10",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((c) => (
        <div key={c.label} className="card p-4">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${c.bg}`}>
              <c.icon className={`w-4 h-4 ${c.color}`} />
            </div>
            <div>
              <p className="text-[11px] text-gray-500 uppercase tracking-wider">
                {c.label}
              </p>
              <p className={`text-lg font-semibold ${c.color}`}>{c.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
